import { sample } from 'effector';
import { convertUTCDateToLocalDate } from '@tools/formatDateWithZone';
import { formatPayloadDate } from '../../libs';
import { $ticketData, entityApi } from '../ticket/ticket.model';
import { fxSetPlannedDate } from './ticket-time.model';

sample({
  clock: entityApi.update,
  fn: ({ id, planned_start_at, planned_end_at }) => ({
    ticket: { id },
    planned_start_at: planned_start_at ? formatPayloadDate(planned_start_at) : null,
    planned_end_at: planned_end_at ? formatPayloadDate(planned_end_at) : null,
  }),
  target: fxSetPlannedDate,
});

sample({
  clock: fxSetPlannedDate.doneData,
  source: $ticketData,
  fn: (ticketData, { ticket }) => ({
    ...ticketData,
    planned_start_at: ticket.planned_start_at
      ? new Date(convertUTCDateToLocalDate(new Date(ticket.planned_start_at)))
      : '',
    planned_end_at: ticket.planned_end_at
      ? new Date(convertUTCDateToLocalDate(new Date(ticket.planned_end_at)))
      : '',
  }),
  target: $ticketData,
});
